module.exports = __webpack_public_path__ + "img/wenda_header.e8093111.png";